import { User } from "../../../interfaces/User";

//mockdata
export const mockUser: User = {
  id: 10210,
  givenName: "Erna",
  familyName: "Smith",
  address: "Merikontie 4B17",
  postalCode: "00260",
  municipality: "Helsinki",
  birthDate: "01311982",
  phoneNumber: "+358507773810",
  email: "erna@gmail.com",
  personalIdCodeRecorded: true,
  noPersonalIdCode: false,
  language: "en",
  emailReceiveVerified: false,
  selfieRecorded: true,
  selfieVerified: true,
  selfieRejected: false,
  driversLicenseRecorded: true,
  driversLicenseVerified: false,
  driversLicenseRejected: true,
  customerCanUseChauffeur: true,
  identityVerified: false,
  isIdentityProcessCustomer:true,
  company:{
    name:null,
    vatNumber:null,
    reference:null
  },
  country:"South Africa",
  mayUseQuota: true,
  member : true,
  couponCode: null, //"DEVFORWASH"
  tos: false,
  saveToCustomer: true,
};
